import { Plus } from "lucide-react";

import { IgButton, IgButtonProps } from "@intelligems/ig-theme";
import { Grid, useTheme } from "@mui/material";

interface AddConditionButtonProps {
  onClick: () => void;
  type: "and" | "or" | "add";
  color?: IgButtonProps["color"];
  nested?: boolean;
  disabled?: boolean;
}

export const AddConditionButton = ({
  onClick,
  type,
  nested,
  disabled,
  color = "primary",
}: AddConditionButtonProps) => {
  const theme = useTheme();

  return (
    <Grid
      item
      sx={{
        ...(nested && { marginLeft: "14px", marginBottom: "15px" }),
      }}
    >
      <IgButton
        onClick={onClick}
        disabled={disabled}
        color={color}
        size="small"
      >
        <Plus
          size={18}
          color={
            color === "link"
              ? theme.igIconColors.accent
              : color === "secondary"
                ? theme.igIconColors.light
                : theme.igIconColors.dark
          }
          style={{
            marginRight: 1,
          }}
        />
        {type === "and"
          ? "AND Condition"
          : type === "or"
            ? "OR Condition"
            : "Add Condition"}
      </IgButton>
    </Grid>
  );
};
